module.exports = __webpack_public_path__ + "img/ro.19ca6a34.svg";